import { render } from "./paginationMax50.vue?vue&type=template&id=4399ab5b"
import script from "./paginationMax50.vue?vue&type=script&lang=js"
export * from "./paginationMax50.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__